// ignore-string-externalization

import styled from 'styled-components';
import {
  Type,
  screenSmMax,
  cta2FontSize,
} from '@spotify-internal/encore-web-v5';
import {
  AnimationContextType,
  DELAYS,
  fadeInAnimation,
  withAnimationContext,
} from '@spotify-internal/frodor-modules';

export const StyledSupertext = styled(Type.h6).attrs({
  variant: 'ballad',
  weight: 'book',
})<{ centered?: boolean; animationContext: AnimationContextType }>`
  ${fadeInAnimation(DELAYS.FIRST)};
  text-align: ${({ centered }) => (centered ? 'center' : 'left')};
  text-transform: uppercase;
  padding-bottom: 0px;

  @media (max-width: ${screenSmMax}) {
    font-size: ${cta2FontSize};
  }
`;

export const Supertext = withAnimationContext(StyledSupertext);
